import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from "@angular/router";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {LoadingSpinnerModule} from "@app/presentation/components/loading-spinner/loading-spinner.module";
import {DeliveryPointServiceModule} from "@app/presentation/services/delivery-point/delivery-point-service.module";
import {DialogsModule} from "@app2u/dialogs";
import {TranslateModule} from "@ngx-translate/core";
import {AngularSvgIconModule} from "angular-svg-icon";
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {AppBarModule} from '../app-bar/app-bar.module';
import {RadioButtonModule} from '../radio-button/radio-button.module';
import {
    ChangeDeliveryPointBottomSheetComponent
} from './change-delivery-point-bottom-sheet/change-delivery-point-bottom-sheet.component';
import {ChangeDeliveryPointModalComponent} from './change-delivery-point-modal/change-delivery-point-modal.component';
import {DeliveryPointItemComponent} from './delivery-point-item/delivery-point-item.component';
import {DeliveryPointListComponent} from './delivery-point-list/delivery-point-list.component';
import {DeliveryPointsComponent} from './delivery-points.component';

@NgModule({
    declarations: [
        DeliveryPointsComponent,
        DeliveryPointListComponent,
        DeliveryPointItemComponent,
        ChangeDeliveryPointBottomSheetComponent,
        ChangeDeliveryPointModalComponent
    ],
    exports: [
        DeliveryPointsComponent
    ],
    imports: [
        CommonModule,
        LoadingSpinnerModule,
        ButtonModule,
        AngularSvgIconModule,
        TranslateModule,
        DialogsModule,
        RouterModule,
        DeliveryPointServiceModule,
        AppBarModule,
        ButtonModule,
        RadioButtonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxSkeletonLoaderModule
    ]
})
export class DeliveryPointsModule { }
